import {Common} from '../../types/models/Common';
import {
  CLOSE_SNACKBAR,
  CommonActionTypes,
  FETCH_ERROR,
  FETCH_SUCCESS,
  HIDE_MESSAGE,
  SHOW_MESSAGE,
  SHOW_WARNING,
  TOGGLE_APP_DRAWER,
} from '../../types/actions/Common.action';

const INIT_STATE: Common = {
  error: '',
  loading: false,
  isAppDrawerOpen: false,
  updatingContent: false,
  message: '',
  notifications: [],
};

export default (state = INIT_STATE, action: CommonActionTypes): Common => {
  switch (action.type) {
    case FETCH_SUCCESS: {
      return {
        ...state,
        error: '',
        message: '',
        loading: false,
        updatingContent: false,
      };
    }
    case SHOW_MESSAGE: {
      const notifications = [...state.notifications];
      notifications.push({
        type: 'success',
        message: action.message,
        key: Date.now() + Math.random(),
      });
      return {
        ...state,
        notifications,
        error: '',
        message: action.message,
        loading: false,
        updatingContent: false,
      };
    }
    case FETCH_ERROR: {
      const notifications = [...state.notifications];
      notifications.push({
        type: 'error',
        message: action.error,
        key: Date.now() + Math.random(),
      });
      return {
        ...state,
        notifications,
        loading: false,
        error: action.error,
        message: '',
        updatingContent: false,
      };
    }
    case CLOSE_SNACKBAR: {
      return {
        ...state,
        notifications: state.notifications.filter(
          ({key}) => key !== action.payload,
        ),
      };
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        loading: false,
        error: '',
        message: '',
        updatingContent: false,
      };
    }
    case TOGGLE_APP_DRAWER: {
      return {
        ...state,
        isAppDrawerOpen: !state.isAppDrawerOpen,
      };
    }
    case SHOW_WARNING: {
      const notifications = [...state.notifications];
      notifications.push({
        type: 'warning',
        message: action.message,
        key: Date.now() + Math.random(),
      });
      return {
        ...state,
        notifications,
        error: '',
        message: action.message,
        loading: false,
        updatingContent: false,
      };
    }
    default:
      return state;
  }
};
